<lib-placeholder iconName="cancel" iconClass="icon-error" message="Error loading resources"
    [condition]="(this.repo.error$ | async) ?? false"></lib-placeholder>
<lib-placeholder iconName="warning" iconClass="icon-info"
    [message]="message"
    [condition]="!((this.repo.loading$ | async) ?? false) && data.length === 0"></lib-placeholder>